import React from "react";
import AppRoutes from "Routes";
import MSClarity from "component/MSClarity";
import { CLARITY_ID } from "./config";

export default function App() {
   return (
      <>
         <AppRoutes />
         <MSClarity clarityId={CLARITY_ID} />
      </>
   );
}
